"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Status = exports.Aproove = void 0;

var _EventHandler = _interopRequireDefault(require("../../../Events/EventHandler"));

var _User = _interopRequireDefault(require("../../Account/User"));

var _Order = require("../../Order");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Aproove = {
  REJECTED: -1,
  WAITING: 0,
  ACCEPTED: 1
};
exports.Aproove = Aproove;
const Status = {
  REJECTED: -2,
  WAITING: 0,
  PROCESSING: 1,
  PAYED: 2
};
exports.Status = Status;

class Payer extends _EventHandler.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "id", null);

    _defineProperty(this, "user", null);

    _defineProperty(this, "paymentMethod", null);

    _defineProperty(this, "method", null);

    _defineProperty(this, "amount", null);

    _defineProperty(this, "changeFor", null);

    _defineProperty(this, "status", Status.WAITING);

    _defineProperty(this, "aproove", Aproove.WAITING);

    _defineProperty(this, "chargeId", null);
  }

  validate() {
    if (this.user && !this.trigger('payer/getUser')) {
      throw new Error('Usuário não encontrado!');
    }

    let order = this.trigger('payer/getOrder');

    if ([_Order.OrderOrigin.APP, _Order.OrderOrigin.PHONE].indexOf(order.origin) > -1 && !this.user) {
      throw new Error('Usuário não encontrado!');
    }

    if (this.aproove == Aproove.WAITING) {
      return false;
    }

    let available = this.trigger('payer/getAvailableMethods');
    let availableMethods = available.map(method => method.alias + ':' + method.type);

    if (availableMethods.indexOf(`${this.method}:${this.paymentMethod}`) == -1) {
      throw new Error('Método de pagamento não encontrado!');
    }

    return true;
  }

  static fromObject(obj) {
    let payer = new Payer();
    Object.keys(obj || {}).forEach(prop => {
      switch (prop) {
        case 'user':
          payer.user = obj[prop] ? new _User.default(obj[prop]) : obj[prop];
          break;

        case 'paymentMethod':
        case 'payment_method':
          payer.paymentMethod = obj[prop];
          break;

        case 'changeFor':
        case 'change_for':
          payer.changeFor = obj[prop];
          break;

        case 'id':
        case 'method':
        case 'amount':
        case 'status':
        case 'aproove':
        case 'chargeId':
          payer[prop] = obj[prop];
          break;
      }
    });
    return payer;
  }

}

exports.default = Payer;